import {getDefaultConfig} from '@utils/omicron';

import {OmicronConfigSchema, OmicronContent, OmicronDTO} from './types';

export const OMICRON_DEFAULT_RESPONSE: OmicronDTO = {
  config_v: 0,
  oid: '',
  cond_s: '',
  config: getDefaultConfig<OmicronContent>(OmicronConfigSchema),
  segments: {},
};

export const OMICRON_PARAMS = 'omicronParams';
export const USER_ID = 'userId';
